<template>
  <div class="d-flex align-items-center">
    <div
      class="seat-map-header flex-grow d-flex flex-row flex-lg-column flex-xl-column"
    >
      <!-- Desktop view -->
      <div class="d-none d-lg-block d-xl-block">
        <span
          v-if="isEditing"
          class="d-flex flex-column"
          style="gap: 5px"
        >
          <flight-segment-display
            :current-segment-index="currentSegmentIndex"
            :total-segments="totalSegments"
            :segment="currentSegment"
            :locations="locations"
          />
          <passenger-context-display
            :passenger="currentPassenger"
            :is-holding-infant="isPassengerHoldingInfant"
          />
        </span>
        <selection-instructions v-else />
      </div>

    </div>

    <div>
      <vb-button
        v-if="!isEditing"
        class="d-flex mr-4"
        :vb_options="{
          variant: 'outline-info',
          size: 'sm',
          role: 'button',
        }"
        @click="$emit('toggle-edit')"
      >
        <span
          class="text-decoration-underline font-size-14px d-flex justify-content-center align-items-center"
        >
          <vb-icon
            name="pen"
            :color="sass('info')"
            :size="14"
            class="mr-2"
          />
          <span>Modifica</span>
        </span>
      </vb-button>
    </div>
  </div>
</template>

<script>
import FlightSegmentDisplay from './flight-segment-display.vue'
import PassengerContextDisplay from './passenger-context-display.vue'
import SelectionInstructions from '../messages/selection-instructions.vue'

export default {
  name: 'SeatMapHeader',
  components: {
    FlightSegmentDisplay,
    PassengerContextDisplay,
    SelectionInstructions,
  },
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
    currentSegmentIndex: Number,
    totalSegments: Number,
    currentSegment: Object,
    currentItinerary: Object,
    currentPassenger: Object,
    isPassengerHoldingInfant: {
      type: Boolean,
      default: false,
    },
    locations: Object,
  },
  methods: {
    sass(colorName) {
      // Pass through to parent's sass helper or implement locally
      return this.$parent.sass ? this.$parent.sass(colorName) : colorName
    },
  },
}
</script>
